module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAElBMVEUAAACQYGCAeHD/ZdX/xf/4+Phd0A38AAAAAXRSTlMAQObYZgAAAGlJREFUeNpdjtENgDAIBWviABo3gHQAi/yb6AQk7L+KUNSEHvxw4dGW+U6c5aLEUWjAhCpaiQojowuBCuJdP0GM4g0iEemThagiRYS78016I+Cin/hvqMQjLoAagtGwhRg+tuV5L9OaWB5+NSz10NielwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Fairy.png
// module id = 161
// module chunks = 0